export default __webpack_public_path__ + "static/prompt-latin-500-normal-5676c5c1b806f8aa695fc256f9dee045.woff2";